document.addEventListener("DOMContentLoaded", function () {
        const menu = document.querySelector(".menu");
        const menuMain = menu.querySelector(".menu-main");
        const goBack = menu.querySelector(".go-back");
        const menuTrigger = document.querySelector(".mobile-menu-trigger");
        const closeMenu = menu.querySelector(".mobile-menu-close");
        let subMenu;

        // Menu and submenu event listeners
        menuMain.addEventListener("click", (e) => {
          if (!menu.classList.contains("active")) {
            return;
          }
          // Handle submenu clicks
          if (e.target.closest(".menu-item-has-children")) {
            const hasChildren = e.target.closest(".menu-item-has-children");
            showSubMenu(hasChildren);
          }
        });

        // Handle subcategory clicks
        document.addEventListener("click", (e) => {
          if (e.target.closest(".subcategoryhead")) {
            const head = e.target.closest(".subcategoryhead");
            toggleSubCategory(head);
          }
        });

        goBack.addEventListener("click", () => {
          hideSubMenu();
        });

        menuTrigger.addEventListener("click", () => {
          toggleMenu();
        });

        closeMenu.addEventListener("click", () => {
          toggleMenu();
        });

        document
          .querySelector(".menu-overlay")
          .addEventListener("click", () => {
            toggleMenu();
          });

        // Toggle menu visibility
        function toggleMenu() {
          menu.classList.toggle("active");
          document.querySelector(".menu-overlay").classList.toggle("active");
        }

        // Show submenu
        function showSubMenu(hasChildren) {
          subMenu = hasChildren.querySelector(".sub-menu");
          if (subMenu) {
            subMenu.classList.add("active");
            subMenu.style.animation = "slideLeft 0.5s ease forwards";
            const menuTitle =
              hasChildren.querySelector("i")?.parentNode?.childNodes[0]
                ?.textContent || "";
            menu.querySelector(".current-menu-title").innerHTML = menuTitle;
            menu.querySelector(".mobile-menu-head").classList.add("active");
          } else {
            console.error("Submenu not found");
          }
        }

        // Hide submenu
        function hideSubMenu() {
          if (subMenu) {
            subMenu.style.animation = "slideRight 0.5s ease forwards";
            setTimeout(() => {
              subMenu.classList.remove("active");
            }, 300);
            menu.querySelector(".current-menu-title").innerHTML = "";
            menu.querySelector(".mobile-menu-head").classList.remove("active");
          }
        }

        // Toggle subcategory visibility
        function toggleSubCategory(head) {
          const subcategory = head.nextElementSibling; // Assumes subcategory is the next sibling
          if (subcategory && subcategory.classList.contains("subcategory")) {
            // Toggle display of subcategory
            if (
              subcategory.style.display === "block" ||
              getComputedStyle(subcategory).display === "block"
            ) {
              subcategory.style.display = "none";
            } else {
              subcategory.style.display = "block";
            }
          } else {
            console.error("Subcategory not found or not a sibling");
          }
        }

        // Handle window resize
        window.onresize = function () {
          if (this.innerWidth > 991) {
            if (menu.classList.contains("active")) {
              toggleMenu();
            }
          }
        };
      });